// types de User Register y login
export const DO_REGISTER = "DO_REGISTER";
export const DO_LOGIN = "DO_LOGIN";
export const UPDATE_USER = "UPDATE_USER";
//types de Cart

export const ADD_ARTICLE = "ADD_ARTICLE";
export const DELETE_ARTICLE = "DELETE_ARTICLE";
